import styled from 'styled-components';
import { FOOTER_OPACITY } from '../../utils/common';

export const FooterContainer = styled.div`
  width: 100%;
  position: relative;
  &.bg_type_image {
    background: ${(props) =>
      props?.propsBackground?.content[0]?.image_url
        ? `url(${props?.propsBackground?.content[0]?.image_url})`
        : `none, ${props?.propsBackground?.default || props?.themeBackground}`};
    background-size: cover;
    background-position: center;
  }
  &.bg_type_solid {
    background: ${(props) => props?.themeBackground?.backgroundColor};
  }
  &.bg_type_image::after {
    content: '';
    background: ${(props) => props?.themeBackground};
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: ${FOOTER_OPACITY};
    z-index: 1;
  }
  color: ${(props) => props?.themeBackground?.body?.color};
`;

export const FooterDesktopContainer = styled.div`
  width: 100%;
  padding: 2.5rem 4rem;
  display: flex;
  z-index: 10;
  position: relative;
  & .left-container {
    display: flex;
    flex-direction: column;
    gap: 2.5rem;
    flex: 1;
  }
  & .left-container .addressContainer {
    display: flex;
    flex-wrap: wrap;
    text-align: left;
    font-size: 0.813rem;
    font-weight: 500;
    line-height: 22px;
    width: 80%;
    color: ${(props) => props?.themeBackground?.body?.color};
    font-family: ${(props) => props?.themeBackground?.body?.fontFamily};
    font-weight: ${(props) => props?.themeBackground?.body?.fontWeight};
    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */
    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */
  }
  & .left-container .addressContainer .address {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    color: ${(props) => props?.themeBackground?.body?.color};
    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */
    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */
  }
  & .left-container .addressContainer .address .contact {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */
    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */
  }
  & .logo-container {
    display: flex;
    justify-content: flex-start;
  }
  & .middle-container {
    flex: 0.8;
    align-items: center;
  }
  & .right-container {
    display: flex;
    flex-direction: column;
    gap: 2.5rem;
  }
  & .middle-container .privacy-terms-container {
    display: flex;
    gap: 1.5rem;
    font-size: 0.875rem;
    text-align: center;
    color: ${(props) => props?.themeBackground?.buttonSecondary?.color};
    font-family: ${(props) => props?.themeBackground?.buttonSecondary?.fontFamily};
    font-weight: ${(props) => props?.themeBackground?.buttonSecondary?.fontWeight};
    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */
    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */
  }
  & .middle-container .privacy-terms-container .privacy-policy {
    display: flex;
    flex-wrap: wrap;
  }
  & .right-container {
    align-items: flex-end;
    flex: 0.6;
  }
  & .right-container .footer-rights-container {
    text-align: right;
    display: flex;
    flex-direction: column;
    gap: 0.563rem;
    opacity: 0.6;
  }
  & .right-container .social-media-section {
    display: flex;
    justify-content: space-between;
  }
  & .right-container .footer-rights-container .copyright,
  & .right-container .footer-rights-container .copyright-sub-text {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    font-style: normal;
    color: ${(props) => props?.themeBackground?.body?.color};
    font-family: ${(props) => props?.themeBackground?.body?.fontFamily};
    font-weight: ${(props) => props?.themeBackground?.body?.fontWeight};
    opacity: 0.6;
    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */
    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */
  }
  & .right-container .footer-rights-container .copyright {
    font-size: 0.75rem;
  }
  & .right-container .footer-rights-container .copyright-sub-text {
    font-size: 0.625rem;
  }
`;

export const FooterMobileContainer = styled.div`
  display: flex;
  padding: 2.5rem 1rem;
  flex-direction: column;
  gap: 2.5rem;
  z-index: 10;
  position: relative;
  & > .first-container {
    flex-direction: column;
    gap: 1.5rem;
  }
  & .first-container .privacy-terms-container {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    font-size: 0.875rem;
    text-align: left;
    color: ${(props) => props?.themeBackground?.buttonSecondary?.color};
    font-family: ${(props) => props?.themeBackground?.buttonSecondary?.fontFamily};
    font-weight: ${(props) => props?.themeBackground?.buttonSecondary?.fontWeight};
    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */
    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */
  }
  & > .second-container .social-media-section {
    display: flex;
    justify-content: flex-start;
  }
  & .third-container .addressContainer {
    display: flex;
    flex-wrap: wrap;
    text-align: left;
    font-size: 0.813rem;
    line-height: 22px;
    color: ${(props) => props?.themeBackground?.body?.color};
    font-family: ${(props) => props?.themeBackground?.body?.fontFamily};
    font-weight: ${(props) => props?.themeBackground?.body?.fontWeight};
    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */
    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */
  }
  & .third-container .addressContainer .address {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */
    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */
  }
  & .third-container .addressContainer .address .contact {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */
    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */
  }
  & > .fourth-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  & > .fifth-container .footer-rights-container .copyright,
  & > .fifth-container .footer-rights-container .copyright-sub-text {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    opacity: 0.6;
    font-style: normal;
    color: ${(props) => props?.themeBackground?.body?.color};
    font-family: ${(props) => props?.themeBackground?.body?.fontFamily};
    font-weight: ${(props) => props?.themeBackground?.body?.fontWeight};
    overflow-wrap: break-word; /* Fallback for browsers that don't support 'anywhere' */
    overflow-wrap: anywhere; /* Use 'anywhere' for more flexible line breaking */
  }
  & > .fifth-container .footer-rights-container .copyright {
    font-size: 0.75rem;
  }
  & > .fifth-container .footer-rights-container .copyright-sub-text {
    font-size: 0.625rem;
  }
`;
